import { Injectable } from '@angular/core';
import { DataEntity } from '../models/data-entities/data-entity';

@Injectable()
export class TemplateService {
  generateToken(de: DataEntity): string {
    return '${' + de.templateCode + '}';
  }
}
